import { createContext, useContext, useState, useEffect } from "react";
import Axios from "../api/axios/Axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAuth = async () => {
      try {
        const res = await Axios.get("/api/auth/user");
        if (res.data && res.data.isAuthenticated) {
          setAuth(res.data);
        } else {
          setAuth({ isAuthenticated: false });
        }
      } catch (err) {
        console.error("Auth check failed:", err);
        setAuth({ isAuthenticated: false });
      } finally {
        setLoading(false);
      }
    };

    fetchAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ auth, setAuth, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
